var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.6664 22.5V20.8333C21.6664 19.9493 21.3152 19.1014 20.6901 18.4763C20.065 17.8512 19.2171 17.5 18.3331 17.5H11.6664C10.7823 17.5 9.9345 17.8512 9.30938 18.4763C8.68426 19.1014 8.33307 19.9493 8.33307 20.8333V22.5","stroke":"white","strokeWidth":"1.73913","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15.0003 14.1667C16.8412 14.1667 18.3336 12.6743 18.3336 10.8333C18.3336 8.99238 16.8412 7.5 15.0003 7.5C13.1593 7.5 11.6669 8.99238 11.6669 10.8333C11.6669 12.6743 13.1593 14.1667 15.0003 14.1667Z","stroke":"white","strokeWidth":"1.73913","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("circle",{"cx":"15","cy":"15","r":"14","stroke":"white","strokeWidth":"2","key":2})]);
}

Account.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Account;

Account.default = Account;
